import React from 'react';
import PropTypes from 'prop-types';
import PanelSection from 'components/v2/PanelSection';
import Button from 'components/v2/buttons/Button';
import classnames from 'classnames';
import LoadingCircle from 'components/ui/LoadingCircle';
export default function CardFooter({ children, actionLabel, cancelLabel, className, onActionClick, onCancelClick, showCancelButton, cancelLink, otherActions, disabled = false, showSpinner = false, actionTestDataId, cancelTestDataId, }) {
    return (React.createElement(PanelSection, { className: classnames(className, 'bg-gray-50') },
        React.createElement("div", { className: "flex items-center justify-end" },
            children,
            React.createElement("div", { className: "flex items-center justify-end space-x-4" },
                React.createElement(Button, { color: "green", onClick: onActionClick, disabled: disabled, className: "flex items-center", testDataId: actionTestDataId },
                    showSpinner && React.createElement(LoadingCircle, { color: "white" }),
                    actionLabel),
                otherActions && otherActions(),
                showCancelButton && onCancelClick && (React.createElement(Button, { color: "", onClick: onCancelClick, disabled: disabled, testDataId: cancelTestDataId }, cancelLabel)),
                showCancelButton && cancelLink && (React.createElement(Button, { color: "", href: cancelLink, disabled: disabled, testDataId: cancelTestDataId }, cancelLabel))))));
}
CardFooter.propTypes = {
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
    actionLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    onActionClick: PropTypes.func,
    onCancelClick: PropTypes.func,
    showCancelButton: PropTypes.bool,
    cancelLink: PropTypes.string,
    otherActions: PropTypes.func,
    actionTestDataId: PropTypes.string,
    cancelTestDataId: PropTypes.string,
};
CardFooter.defaultProps = {
    actionLabel: 'Save',
    cancelLabel: 'Cancel',
    showCancelButton: true,
};
